<app-base-send-sms
  formId="sendSmsWithPhonebookForm"
  [childTagName]="tagName"
  [config]="baseSendSmsConfig"
  [form]="form"
  [loading]="loading"
  [editModel]="formPageConfig.editData"
  [campaignTitle]="model.title"
  (model)="getBaseSendSmsModel($event)"
  (onSubmit)="onSubmit()"
  [saveToCampaign]="model.saveToCampaign"
  (privateNumber)="getPrivateNumber($event)"
  (onSaveToCampaign)="onSaveToCampaign($event)"
>
  <!-- part 2 phonebook Recipients -->
  <fieldset receivers class="tw-h-full">
    <legend class="tw-flex-center">
      <i class="mdi mdi-account-group tw-ml-2"></i>
      {{ "common.receivers" | translate }}
    </legend>

    <!-- phonebooks -->
    <div class="tw-flex-center">
      <div class="send-sms-phonebook tw-w-full">
        <phonebook-selector
          (recipientsChange)="
            getPhonebookRecipients($event); changeFormStatus()
          "
          (globalIndexChange)="getGlobalIndex($event)"
        >
        </phonebook-selector>
      </div>
    </div>
  </fieldset>

  <!-- calcLoading -->
  <app-special-loading *ngIf="calcLoading" special-loading type="calculate">
  </app-special-loading>

  <!-- sendLoading -->
  <app-special-loading *ngIf="sendLoading" special-loading type="sending">
  </app-special-loading>
</app-base-send-sms>
